/**
 * ReasoningSidebar — the chat's "Show reasoning" panel body.
 *
 * Renders the standard side-panel chrome (SlideoutMenu.Header / .Content) so
 * the panel matches every other docked surface. The host column supplies the
 * container (DockedSidePanel on desktop, a full-screen wrapper on mobile) and
 * the dismissal contract via SurfaceDismissContext — the header's close
 * button comes from the chrome, not from a prop threaded to a raw button.
 */

import { CubeOutline } from '@untitledui/icons';

import { SlideoutMenu } from '@/lib/base/overlays/slideout-menu';

import type { ReasoningStepData } from './ReasoningStepsList';
import { ReasoningStepsList } from './ReasoningStepsList';

interface Chain {
  id: string;
  user_message: string;
  status: string;
  steps: ReasoningStepData[];
}

interface ReasoningSidebarProps {
  chain: Chain | null;
  onOpenDynamicViewSidebar: (viewId: number) => void;
}

export function ReasoningSidebar({
  chain,
  onOpenDynamicViewSidebar,
}: ReasoningSidebarProps) {
  if (!chain) {
    return null;
  }

  return (
    <>
      <SlideoutMenu.Header>
        <div className='flex items-center gap-2'>
          <CubeOutline
            className='size-5 shrink-0 text-fg-primary'
            strokeWidth={1.5}
            aria-hidden='true'
          />
          <h2 className='text-lg font-semibold text-primary'>Reasoning</h2>
        </div>
      </SlideoutMenu.Header>
      <SlideoutMenu.Content>
        <ReasoningStepsList
          steps={chain.steps}
          listId={chain.id}
          onOpenDynamicViewSidebar={onOpenDynamicViewSidebar}
        />
      </SlideoutMenu.Content>
    </>
  );
}
